import { useHistory, useLocation } from "react-router-dom";
import images from "../../../../../../../../../utilities/images/images";
import { goBackFromPackagePage } from "../../../../../../../../../custom_utilities/dashboardBannerNavigation";
import "./StoreBanner.scss";

export const StoreBanner = (props) => {
  const { packageData } = props;
  const history = useHistory();
  const location = useLocation();

  const goBack = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    goBackFromPackagePage(history, location);
  };

  return (
    <div className="user-dashboard-store-banner-inner-wrapper">
      <div className="storeBack" onClick={goBack}>
        <img src={images.storeBck} alt="Back" />
        <span>Back</span>
      </div>

      <div className="store-banner-content-and-btn-wrapper">
        <img src={packageData?.icon} alt="Banner" className="banner-image" />
      </div>
    </div>
  );
};
